import { useQueryHelper } from '@anytag/shared-hooks';
import { useInstagramComparePostDetailsQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPostId } = usePostModalContext();
  const { data, loading } = useInstagramComparePostDetailsQuery({
    skip: !selectedPostId,
    fetchPolicy: 'cache-and-network',
    variables: { postId: Number(selectedPostId) },
    onError: (err) => {
      closeModal?.();
      enqueueSnackbar(t(err.message), { variant: 'error' });
    }
  });

  const details = data?.instagramComparePostDetails;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={
        details
          ? {
              socialMedia: 'INSTAGRAM',
              postUrl: details.postUrl,
              caption: details.content,
              postDate: details.postDate,
              comments: details.commentList || [],
              images: details.postImageUrl ? [details.postImageUrl] : [],
              statistics: { likes: details.analysis?.likes, comments: details.analysis?.comments },
              info: {
                avatar: details.avatarUrl,
                followers: details.followers,
                name: details.instagramAccountName
              }
            }
          : undefined
      }
    />
  );
};
